import { apiClient } from '../client'
import { RunDetail } from '../../app/modules/types/scan'

/**
 * Workflow run API. Two URL families on the orchestrator:
 *   - workflow/<id>/run/           — POST: start a run for a specific workflow
 *   - workflow/<id>/runs/          — GET:  list runs of a specific workflow
 *   - run/                         — GET:  list all runs across the org
 *   - run/<id>/                    — GET / DELETE: detail / remove
 *   - run/<id>/cancel/             — POST: cancel a running workflow
 */
export const runsApi = {
  /** Trigger a new run for a workflow. */
  trigger: async (workflowId: string, payload: any): Promise<any> => {
    const { data } = await apiClient.post(`/workflow/${workflowId}/run/`, payload)
    return data
  },

  /** List runs of a specific workflow (workflow-scoped). */
  listForWorkflow: async (workflowId: string, params?: string): Promise<any> => {
    const url = params
      ? `/workflow/${workflowId}/runs/?${params}`
      : `/workflow/${workflowId}/runs/`
    const { data } = await apiClient.get(url)
    return data
  },

  /** List runs across all workflows for the active org. */
  list: async (params?: string): Promise<any> => {
    const url = params ? `/run/?${params}` : '/run/'
    const { data } = await apiClient.get(url)
    return data
  },

  /** Get one run with its node-execution detail (graph_snapshot + node_executions). */
  getById: async (runId: string, signal?: AbortSignal): Promise<RunDetail> => {
    const { data } = await apiClient.get<RunDetail>(`/run/${runId}/`, { signal })
    return data
  },

  /** Cancel a running run. Returns the updated run detail. */
  cancel: async (runId: string): Promise<any> => {
    const { data } = await apiClient.post(`/run/${runId}/cancel/`)
    return data
  },

  /** Delete a completed/cancelled run. */
  remove: async (runId: string): Promise<void> => {
    await apiClient.delete(`/run/${runId}/`)
  },
}
